export interface FuneralHomeProps {
  id: string;
  ticker: string;
  name: string;
  phone: string;
  schedule: string;
  address: string;
  city: string;
  country: string;
  state: string;
  property_id: string;
}

export class FuneralHome {
  private constructor(
    public readonly id: string,
    public readonly ticker: string,
    public readonly name: string,
    public readonly phone: string,
    public readonly schedule: string,
    public readonly address: string,
    public readonly city: string,
    public readonly country: string,
    public readonly state: string,
    public readonly propertyId: string
  ) {}

  static of(props: FuneralHomeProps): FuneralHome {
    return new FuneralHome(
      props.id,
      props.ticker,
      props.name,
      props.phone,
      props.schedule,
      props.address,
      props.city,
      props.country,
      props.state,
      props.property_id
    );
  }

  static create(props: Omit<FuneralHomeProps, "id">): FuneralHome {
    return FuneralHome.of({ ...props, id: crypto.randomUUID() });
  }
}
